import axios from 'axios';
import { UpsertTypeEnum } from '../../@types/enum/upsertType';
import { IDamConstructionTypeUpsert } from '../../@types/modelV2/masterData/dam/damConstructionType/damConstructionTypeUpsert';
import { IDamConstructionType } from '../../@types/modelV2/masterData/dam/damConstructionType/damConstructionType';

export default class DamConstructionTypeHttpService {
    public static getList = async () : Promise<Array<IDamConstructionType>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/DamConstructionType/GetList`);
        return result.data;
    }

    public static upsert = async (upsert : IDamConstructionTypeUpsert, type : UpsertTypeEnum) : Promise<IDamConstructionType> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/DamConstructionType/${type}`, upsert);
        return result.data;
    }

    public static delete = async (damConstructionTypeId : number) : Promise<void> => {
        await axios.delete(`${API_URL}/v1/MasterData/DamConstructionType/Delete`, {
            params: {
                damConstructionTypeId,
            },
        });
    }
}
